import { Component, Input } from '@angular/core';
import { ErrorImportLogItem } from '../../model/error-import-log-item';
import { LogItemHelper } from '../log-item-helper';

@Component({
    selector: 'tnb-error-importlogitem',
    templateUrl: './error-import-log-item.component.html',
    styleUrls: [
        './error-import-log-item.component.scss',
    ],
    standalone: false,
})
export class ErrorImportLogItemComponent {

    @Input() errorImportLogItem: ErrorImportLogItem;

    public formatArray = LogItemHelper.formatArray;

    constructor() {
    }

}
